import styled from '@emotion/styled'
import { useEffect, useRef, useState } from 'react'

const Image = styled.img`
  object-fit: cover;
  object-position: center;
  opacity: 0;
`

// NOTE: The imageRef isn't necessary, but it's useful if you need the reference for the image.
const AnimationImage = ({ animationName='animation__scaleload-200', imageRef, handleError, className, ...rest }) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const isDelayedLoading = useRef(false)
  const timeout = useRef(null)

  // timeout detects if it takes the image too long to load
  // if the loading is delayed, then we want to animate the image entrance
  useEffect(() => {
    timeout.current = setTimeout(() => {
      isDelayedLoading.current = true
    }, 100)

    return () => clearTimeout(timeout.current)
  }, [])

  const loadedClassName = () => {
    if (!isLoaded) return ''
    if (isLoaded && isDelayedLoading.current) {
      return animationName
    } else {
      return 'normal_opacity'
    }
  }

  return (
    <Image
      ref={imageRef}
      onLoad={(e) => setIsLoaded(true)}
      onError={handleError}
      // WARNING, we have to add the classnames like this so we
      // can accept the parent classes from emotion styled components
      // Otherwise the animations get overriden
      className={className + ` ${loadedClassName()}`}
      {...rest}
    />
  )
}

export default AnimationImage
